import moment from 'moment'

export const calcTime = (offset: number): string => {
  // create Date object for current location
  const d = new Date()

  // convert to msec
  // subtract local time zone offset
  // get UTC time in msec
  const utc = d.getTime() + d.getTimezoneOffset() * 60000

  // create new Date object for different city
  // using supplied offset
  const nd = new Date(utc + 3600000 * offset)

  // return time as a string
  // return nd.toLocaleString()
  return nd.getHours() + ':' + nd.getMinutes()
}

export const formatData = (val: string) => {
  return new Date(val).toLocaleString('ru-RU')
}

export const fullDateFormat = (date: string) => moment(date).format('YYYY-MM-DD, HH:mm')
export const dateFormat = (date: string) => moment(date).format('YYYY-MM-DD')

export const getWeek = (date: string) => moment(date).week()
